import { render, staticRenderFns } from "./ReturnProcess.vue?vue&type=template&id=db94b956&scoped=true"
import script from "./ReturnProcess.vue?vue&type=script&lang=js"
export * from "./ReturnProcess.vue?vue&type=script&lang=js"
import style0 from "./ReturnProcess.vue?vue&type=style&index=0&id=db94b956&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db94b956",
  null
  
)

export default component.exports